import { BaseModel } from "../base-model";

export interface IAddressModel {
  CityPostCode?: string;
  CountryId?: number;
  CountryName?: string;
  BoxNr?: string;
  HouseNumber?: string;
  CityName?: string;
  Address1?: string;
  Address2?: string;
  Province?: string;
  GoogleX?: number;
  GoogleY?: number;
}

export class AddressModel extends BaseModel<IAddressModel> {
  HouseNumber?: string;
  CityPostCode?: string;
  CountryId?: number;
  CountryName?: string;
  BoxNr?: string;
  CityName?: string;
  Address1?: string;
  Address2?: string;
  Province?: string;
  GoogleX?: number;
  GoogleY?: number;
  /**
   *
   */
  constructor(option?: IAddressModel) {
    super(option);
  }
}
